import createBuyerIntentView from './createBuyerIntentView'

const BuyerIntentCategoryView = createBuyerIntentView({
  displayName: 'BuyerIntentCategoryView',
  tag: 'categories.show',
})

export default BuyerIntentCategoryView
